import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ConfiguracaoNFeRequest } from '../../requests/dfe/configuracao-nfe.request';
import { ConfiguracaoNFeResponse } from '../../responses/dfe/configuracao-nfe.response';

@Injectable({
  providedIn: 'root',
})
export class ConfiguracaoNFeService extends CommonService {
  private readonly apiUrl = `${environment.urlApiDFe}configuracao-nfe`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  /**
   * Configurações da NF-e da empresa do token. A API cria a linha com os valores padrão quando ainda não existir.
   * Corresponde a: [HttpGet] /configuracao-nfe
   */
  public get(): Observable<ConfiguracaoNFeResponse> {
    return this.httpClient
      .get<ConfiguracaoNFeResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Corresponde a: [HttpPut] /configuracao-nfe */
  public atualizar(request: ConfiguracaoNFeRequest): Observable<ConfiguracaoNFeResponse> {
    return this.httpClient
      .put<ConfiguracaoNFeResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
